import { EasyPurchaseFundKey } from "./types";

const SEPAH_BROKER_FUND_CODES = new Set(["11222", "11197", "11530"]);

export const isSepahBrokerFund = (fundRegisterCode?: string): boolean =>
  SEPAH_BROKER_FUND_CODES.has(String(fundRegisterCode || "").trim());

export const formatNumber = (num: number): string =>
  new Intl.NumberFormat("fa-IR").format(num);

export const formatPercent = (val: number): string => val.toFixed(2);

export const floorWholeUnits = (amount: number, unitPrice: number): number =>
  unitPrice > 0 ? Math.floor(amount / unitPrice) : 0;

export const getFundTypeColor = (type: string): string => {
  if (type.includes("سهامی")) return "red";
  if (type.includes("درآمد ثابت")) return "green";
  if (type.includes("مختلط")) return "purple";
  if (type.includes("کالایی")) return "orange";
  return "gray";
};

const EASY_PURCHASE_FUND_KEYS: Record<string, EasyPurchaseFundKey> = {
  "11141": "NAVID",
  "11383": "OMID",
  "11343": "GANJINEH",
};

export const resolveEasyPurchaseFundKey = (
  fundRegisterCode?: string,
): EasyPurchaseFundKey | null =>
  fundRegisterCode ? EASY_PURCHASE_FUND_KEYS[fundRegisterCode] || null : null;

export const getWageSetting = (
  fund: { wageSettings?: Array<{ name: string; value: string }> } | undefined,
  name: string,
): number => {
  const value = fund?.wageSettings?.find((wage) => wage.name === name)?.value;
  const amount = Number(value || 0);
  return Number.isFinite(amount) ? amount : 0;
};
